/* @flow */

export const braindateUrl = 'https://braindate.com/';
export const mainContentId = 'main-content';
export const notificationsMenuId = 'notifications-menu';
